<template>
    <div class="scroll-y custom-scrollbar">
        <div class="item-news --big">
            <ion-row>
                <ion-col size="12" size-md="8" offset-md="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3" class="pd-0">
                    <div class="image-wrapper">
                        <ion-img id="image" :src="article.image" class="image" :alt="article.title" />
                    </div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="12" size-md="8" offset-md="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3">
                    <div class="padding">
                        <h1 class="h2 text-normal">{{ article.title }}</h1>
                    </div>
                    <div class="padding">
                        <div v-if="loading" class="pd-20 text-center"><span class="loader red"></span></div>
                        <div v-else>
                            <p class="date pd-0">{{ article.createdAtDate }} | {{ article.createdAtTime }}</p>
                            <article class="rte" v-html="article.content"></article>
                        </div>
                        <button class="btn btn-primary" @click="goToKnowledgeZoneList">Wróć do strefy wiedzy</button>
                    </div>
                </ion-col>
            </ion-row>
        </div>
    </div>
</template>

<script>
    import NewsServices from "../../../services/NewsServices";

    export default {
        name: 'KnowledgeZoneSingle',
        props: {
            slug : {
                type: [String, Number],
                requred: true
            }
        },
        data(){
            return{
                loading: true,
                article: {
                    image: null,
                    createdAtDate: null,
                    createdAtTime: null,
                    content: null
                }
            }
        },
        methods: {
            getNews: function () {
                NewsServices.getSingleKnowledgeZone(this.slug)
                    .then( (response) => {
                        this.loading = false;
                        this.article = response.data.data;
                        // FIX scroll to top
                        const element = document.querySelector('#topOfDocument');
                        element.scrollIntoView()
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                    })
            },
            goToKnowledgeZoneList: function () {
                this.$router.push({ name: 'KnowledgeZoneList' })
            }
        },
        mounted(){
            this.getNews();
            window.scrollTo(0, 0);
        }
    }
</script>